/**
 * CustomerOrderHistoryPage — a customer's Orders tab, All history, `/customers/:customerId/orders/history`: its CIS
 * orders and its Tharstern work in one list, from the frozen copy once Tharstern is switched off, each Tharstern row
 * with Order again (v1 completion F5). The customer's id is its code, which the list reads by.
 */
import { useCustomerRouteId } from "../app/components/domain/customers/useCustomerRouteId";
import { CustomerFrame } from "../app/components/domain/customers/CustomerFrame";
import { CustomerOrderHistoryList } from "../app/components/domain/orders/CustomerOrderHistoryList";
import { CustomerOrdersViewSwitch } from "../app/components/domain/orders/CustomerOrdersViewSwitch";

export function CustomerOrderHistoryPage() {
  const customerId = useCustomerRouteId();
  if (customerId === null) return null;
  return (
    <CustomerFrame customerId={customerId} current="orders">
      <div className="space-y-3">
        <CustomerOrdersViewSwitch customerId={customerId} current="history" />
        <CustomerOrderHistoryList customerCode={customerId} />
      </div>
    </CustomerFrame>
  );
}
